import React from "react";
import { ArrowRight } from "lucide-react";
import { newProducts, wa } from "../mock";

export default function NewProducts() {
  return (
    <section id="new-products" data-testid="new-products-section" className="home-section" style={{ scrollMarginTop: 120 }}>
      <div className="container grid items-start gap-10 lg:grid-cols-[0.78fr_1fr]">
        <div className="reveal">
          <p className="eyebrow">New branded IT products</p>
          <h2 className="mt-3 font-heading font-extrabold leading-[1.06]"
              style={{ color: "var(--green-950)", fontSize: "clamp(28px,3.6vw,42px)" }}>
            New product supply is now a major Kapatia division
          </h2>
          <p className="mt-4 text-[17px]" style={{ color: "var(--muted)" }}>
            Kapatia also sources new branded IT products for business requirements, including
            laptops, desktops, displays, networking, UPS and collaboration accessories.
            Availability, invoice, warranty and delivery terms are confirmed per enquiry.
          </p>
          <a href={wa()} target="_blank" rel="noopener noreferrer" data-testid="new-products-quote"
             className="kp-button mt-6 inline-flex items-center gap-2 rounded-xl px-6 py-3.5 font-heading font-bold text-white transition-transform hover:-translate-y-0.5"
             style={{ background: "linear-gradient(135deg, var(--green-800), var(--green-950))", boxShadow: "0 16px 32px rgba(45,106,79,0.22)" }}>
            Ask for New Product Quote <ArrowRight size={18} />
          </a>
        </div>

        <div className="grid gap-3">
          {newProducts.map((p, i) => (
            <div key={p.brand} className="reveal rounded-xl border bg-white p-5 transition-transform hover:translate-x-1"
                 style={{ transitionDelay: `${i * 50}ms`, borderColor: "var(--line)",
                          borderLeft: "6px solid var(--orange-500)", boxShadow: "0 12px 30px rgba(45,106,79,0.07)" }}>
              <strong className="block font-heading text-[19px] font-extrabold" style={{ color: "var(--green-900)" }}>{p.brand}</strong>
              <span className="mt-1 block text-[15px]" style={{ color: "var(--muted)" }}>{p.desc}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
